module.exports = __webpack_public_path__ + "img/alipay-alternative2.a714e7c1.png";